@if (variant === 'rectangle') {
  <div class="col-md-4 col-sm-6" style="padding-top: 50px">
    <div style="display: block; border-radius: 8px; box-shadow: 0 0 18px 0 rgba(141, 151, 158, 0.2)">
      <img src="https://assets.box8.co.in/missing/eatclub.png" [ngStyle]="{ height: imageHeight, width: '100%' }" />
      <div class="padding-20">
        <app-selector [height]="'14px'" [width]="'35%'"></app-selector>
        <app-selector [height]="'10px'" [width]="'70%'"></app-selector>
        <app-selector [height]="'10px'" [width]="'80%'"></app-selector>
        <div style="margin-top: 10px">
          <app-selector [height]="'18px'" [width]="'45px'"></app-selector>
          <app-selector [height]="'30px'" [width]="'100px'" [style]="{ float: 'right' }"></app-selector>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="col-md-4 col-sm-6" style="padding-top: 25px">
    <div style="display: flex; justify-content: space-between" [ngStyle]="{ height: imageHeight }">
      <div style="flex: 1">
        <img src="https://assets.box8.co.in/missing/eatclub.png" [ngStyle]="{ height: imageHeight, width: '100%' }" />
      </div>
      <div class="padding-20" style="flex: 2">
        <app-selector [height]="'14px'" [width]="'35%'"></app-selector>
        <app-selector [height]="'10px'" [width]="'70%'"></app-selector>
        <app-selector [height]="'10px'" [width]="'80%'"></app-selector>
        <div style="margin-top: 10px">
          <app-selector [height]="'18px'" [width]="'45px'"></app-selector>
          <app-selector [height]="'30px'" [width]="'80px'" [style]="{ float: 'right' }"></app-selector>
        </div>
      </div>
    </div>
  </div>
}

